var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfficePrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#1CB978"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 22C25.1 22 25.99 21.1 25.99 20L26 10C26 8.9 25.1 8 24 8H8C6.9 8 6 8.9 6 10V20C6 21.1 6.9 22 8 22H5C4.45 22 4 22.45 4 23C4 23.55 4.45 24 5 24H27C27.55 24 28 23.55 28 23C28 22.45 27.55 22 27 22H24ZM9 10H23C23.55 10 24 10.45 24 11V19C24 19.55 23.55 20 23 20H9C8.45 20 8 19.55 8 19V11C8 10.45 8.45 10 9 10Z",
    fill: "#023A22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficePrint);
export default __webpack_public_path__ + "static/media/office-print.9fd303f80b9decc6cb549d5905b74db0.svg";
export { ForwardRef as ReactComponent };